import PlaybackBaseLoader from "components/shared/PlaybackBaseLoader/PlaybackBaseLoader";

(function() {
  const cfg = window.__playbackConfig;

  PlaybackBaseLoader.configure({
    baseUrl: cfg.baseUrl,
    canaryBaseUrl: cfg.canaryBaseUrl,
    imaUrl: 'https://imasdk.googleapis.com/js/sdkloader/ima3.js',
    drmBlockerToggle: cfg.drmBlockerToggle,
    enableCustomSkipAdButtonToggle: cfg.enableCustomSkipAdButton,
    enableLivestreamingDrmUsingTokenToggle: cfg.enableLivestreamingDrmUsingToken,
    enableRefactoredBannerAdToggle: cfg.enableRefactoredBannerAd,
    enablePremierUserBannerAdsToggle: cfg.enablePremierUserBannerAds,
    useInsecureVpaidModeToggle: cfg.useInsecureVpaidMode,
    enableShowAdsByPackageToggle: cfg.enableShowAdsByPackage,
    enableEmbedHideComponentToggle: cfg.enableEmbedHideComponent,
    enableVp9WebToken: cfg.enableVp9WebToken,
    enableApiForAdsParamsToggle: cfg.enableApiForAdsParams,
    enabledPersistentEmbedTopBar: cfg.enabledPersistentEmbedTopBar,
    enableOpenwrapPubmaticToggle: cfg.enableOpenwrapPubmatic,
    enableNextVideoServiceToggle: cfg.enableNextVideoService,
    loadImaJsOnHead: cfg.loadImaJsOnHead,
    cppWatchpageEnabled: cfg.cppWatchpageEnabled,
    dvrEnabled: cfg.dvrEnabled,
    loadBaseJsInHead: cfg.loadBaseJsInHead
  });
})();
